import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { ChangeStatusActionContext } from "./ChangeStatusActionContext";
import update from "@beeldit/core/services/update";

function useChangeStatus() {
  const { elementId, element, statusId, setShowModal, setBackendFormErrors } = useContext(ChangeStatusActionContext);
  const errorHandler = useErrorHandler();
  const data = {status: statusId, ...element}
  return (onSuccess: any) => {
      update("orders/status", elementId, data)
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useChangeStatus;
